import React from "react";
import PeopleIcon from "@atlaskit/icon/glyph/people";

import { Button } from "../../UI/Button";
import { useModalContext } from "../../contexts/ModalContext/context";
import { LeaveRoommateGroupModal } from "./LeaveRoommateGroupModal";
import useAuth from "../../routes/login/AuthContext";

export const LeaveRoommateGroupButton = () => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const handleRemoveClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Button appearance="primary" iconBefore={<PeopleIcon label="people" />} onClick={handleRemoveClick} isDisabled={isSuperAdminRead()}>
        Remove from matching group
      </Button>
      <LeaveRoommateGroupModal />
    </>
  );
};
